import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, vModelSelect as _vModelSelect, vModelText as _vModelText } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-5 d-flex flex-column text-center text-primary"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-spinner fa-spin font-size-5xl me-2 animated slow flash infinite" }, null, -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "mt-1" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Loading...")
], -1 /* HOISTED */)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  id: "Schedule_Visit_HH",
  class: "task-details"
}
const _hoisted_6 = { class: "container row m-0 p-lg-1 ps-md-2" }
const _hoisted_7 = { class: "form-group col-12 mt-2" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Visit Task ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Non Visit Task ")
const _hoisted_10 = /*#__PURE__*/_createElementVNode("strong", {
  for: "task-name",
  class: "me-2"
}, "Employee:", -1 /* HOISTED */)
const _hoisted_11 = { class: "bold" }
const _hoisted_12 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("strong", { class: "me-2" }, "Agency:", -1 /* HOISTED */)
const _hoisted_14 = {
  key: 0,
  class: "form-group col-12 col-md-8 col-lg-3 mt-lg-2"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { for: "employee" }, " Visit Type: ", -1 /* HOISTED */)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*", -1 /* HOISTED */)
const _hoisted_17 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_18 = {
  key: 1,
  class: "form-group col-12 col-md-8 col-lg-3 mt-md-2"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { for: "assigned-to-list" }, [
  /*#__PURE__*/_createTextVNode(" Patient: "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_20 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_21 = {
  key: 2,
  class: "form-group col-12"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("hr", { class: "ms-0" }, null, -1 /* HOISTED */)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", null, "Visit Orders", -1 /* HOISTED */)
const _hoisted_24 = {
  key: 0,
  class: "w-50"
}
const _hoisted_25 = { class: "table-responsive" }
const _hoisted_26 = { class: "table border border-gray" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("tr", { class: "bg-table-header" }, [
  /*#__PURE__*/_createElementVNode("th", null, "Discipline"),
  /*#__PURE__*/_createElementVNode("th", null, "Frequency"),
  /*#__PURE__*/_createElementVNode("th", null, "Effective Date")
], -1 /* HOISTED */)
const _hoisted_28 = { class: "white-space-pre" }
const _hoisted_29 = { class: "white-space-pre" }
const _hoisted_30 = { key: 1 }
const _hoisted_31 = {
  key: 3,
  class: "form-group col-12"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("hr", { class: "ms-0" }, null, -1 /* HOISTED */)
const _hoisted_33 = { key: 0 }
const _hoisted_34 = { key: 1 }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("p", null, " To schedule visits for the selected user, click on the desired dates in the calendar below: ", -1 /* HOISTED */)
const _hoisted_36 = { class: "form-group col-12 ps-md-2" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("input", { class: "form-control" }, null, -1 /* HOISTED */)
const _hoisted_38 = {
  key: 1,
  class: "invalid-feedback d-block"
}
const _hoisted_39 = {
  key: 0,
  class: "d-flex col-12 justify-content-center"
}
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "form-group col-md-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-wrap flex-md-nowrap" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "me-2 me-md-3" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "calendar-legend scheduled" }),
      /*#__PURE__*/_createTextVNode(" Scheduled ")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "me-2 me-md-3" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "calendar-legend completed" }),
      /*#__PURE__*/_createTextVNode(" Completed ")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "me-2 me-md-3" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "calendar-legend missed" }),
      /*#__PURE__*/_createTextVNode(" Missed ")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "me-2 me-md-3" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "calendar-legend multiple" }),
      /*#__PURE__*/_createTextVNode(" Multiple ")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "me-2 me-md-3" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "calendar-legend disabled" }),
      /*#__PURE__*/_createTextVNode(" Disabled ")
    ])
  ])
], -1 /* HOISTED */)
const _hoisted_41 = [
  _hoisted_40
]
const _hoisted_42 = {
  key: 4,
  class: "form-group col-12 col-md-6 mt-2"
}
const _hoisted_43 = /*#__PURE__*/_createElementVNode("label", { for: "date-to" }, " NVA Date ", -1 /* HOISTED */)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*", -1 /* HOISTED */)
const _hoisted_45 = { class: "input-group date datepickerInput" }
const _hoisted_46 = ["value", "on-change"]
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_48 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_49 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_50 = {
  key: 5,
  class: "form-group col-12 col-md-6 mt-2"
}
const _hoisted_51 = /*#__PURE__*/_createElementVNode("label", { for: "task" }, " Non-Visit Activity ", -1 /* HOISTED */)
const _hoisted_52 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*", -1 /* HOISTED */)
const _hoisted_53 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_54 = {
  key: 6,
  class: "form-group col-12 col-md-6 mt-2"
}
const _hoisted_55 = /*#__PURE__*/_createElementVNode("label", { for: "branch" }, [
  /*#__PURE__*/_createTextVNode(" Branch "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger ms-1" }, "*")
], -1 /* HOISTED */)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("option", { value: "null" }, "Select Branch", -1 /* HOISTED */)
const _hoisted_57 = ["value"]
const _hoisted_58 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_59 = {
  key: 7,
  class: "form-group col-12 col-md-6 mt-2"
}
const _hoisted_60 = /*#__PURE__*/_createElementVNode("label", { for: "travel-start-time" }, " Travel Start Time: ", -1 /* HOISTED */)
const _hoisted_61 = { class: "input-group flex-nowrap" }
const _hoisted_62 = ["value"]
const _hoisted_63 = {
  key: 8,
  class: "form-group col-12 col-md-6 mt-2"
}
const _hoisted_64 = /*#__PURE__*/_createElementVNode("label", { for: "travel-end-time" }, " Travel End Time: ", -1 /* HOISTED */)
const _hoisted_65 = { class: "input-group flex-nowrap" }
const _hoisted_66 = ["value"]
const _hoisted_67 = {
  key: 9,
  class: "form-group col-12 col-md-6 mt-2"
}
const _hoisted_68 = /*#__PURE__*/_createElementVNode("label", { for: "visit-start-time" }, [
  /*#__PURE__*/_createTextVNode(" NVA Start Time: "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_69 = ["value"]
const _hoisted_70 = {
  key: 10,
  class: "form-group col-12 col-md-6 mt-2"
}
const _hoisted_71 = /*#__PURE__*/_createElementVNode("label", { for: "visit-end-time" }, [
  /*#__PURE__*/_createTextVNode(" NVA End Time: "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_72 = ["value"]
const _hoisted_73 = {
  key: 11,
  class: "form-group col-12 col-md-6 mt-2"
}
const _hoisted_74 = /*#__PURE__*/_createElementVNode("label", { for: "destination" }, " Destination ", -1 /* HOISTED */)
const _hoisted_75 = ["value"]
const _hoisted_76 = {
  key: 12,
  class: "form-group col-12 col-md-6 mt-2"
}
const _hoisted_77 = /*#__PURE__*/_createElementVNode("label", { for: "associated-mileage" }, " Associated Mileage: ", -1 /* HOISTED */)
const _hoisted_78 = {
  key: 13,
  class: "d-flex flex-column col-12 mt-2"
}
const _hoisted_79 = { class: "form-group" }
const _hoisted_80 = /*#__PURE__*/_createElementVNode("label", { for: "comments" }, " Comments ", -1 /* HOISTED */)
const _hoisted_81 = {
  key: 2,
  class: "d-flex flex-wrap-reverse flex-md-nowrap justify-content-center my-2"
}
const _hoisted_82 = { key: 0 }
const _hoisted_83 = /*#__PURE__*/_createElementVNode("button", { class: "btn btn-primary" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-spinner fa-spin animated slow flash infinite" })
], -1 /* HOISTED */)
const _hoisted_84 = [
  _hoisted_83
]
const _hoisted_85 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TypeaheadInput = _resolveComponent("TypeaheadInput")!
  const _component_MultiDatePickerHH = _resolveComponent("MultiDatePickerHH")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_TimePicker = _resolveComponent("TimePicker")!
  const _component_SaveNotifyUser = _resolveComponent("SaveNotifyUser")!
  const _component_FormSection = _resolveComponent("FormSection")!

  return (_openBlock(), _createBlock(_component_FormSection, {
    "full-height": false,
    title: "Employee Scheduler",
    "application-id": _ctx.visitDetails.Application,
    "show-product-pill": true,
    "show-background": false
  }, {
    content: _withCtx(() => [
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("section", _hoisted_1, _hoisted_4))
        : (_openBlock(), _createElementBlock("section", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isNva) = $event)),
                    value: false
                  }, null, 512 /* NEED_PATCH */), [
                    [_vModelRadio, _ctx.isNva]
                  ]),
                  _hoisted_8,
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isNva) = $event)),
                    value: true
                  }, null, 512 /* NEED_PATCH */), [
                    [_vModelRadio, _ctx.isNva]
                  ]),
                  _hoisted_9
                ]),
                _hoisted_10,
                _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.visitDetails.FirstName) + " " + _toDisplayString(_ctx.visitDetails.LastName), 1 /* TEXT */),
                (!_ctx.isNva)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_12, [
                      _hoisted_13,
                      _createElementVNode("span", null, _toDisplayString(_ctx.visitDetails.AgencyName), 1 /* TEXT */)
                    ]))
                  : _createCommentVNode("v-if", true)
              ]),
              (!_ctx.isNva)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _hoisted_15,
                    _hoisted_16,
                    _createVNode(_component_TypeaheadInput, {
                      getData: _ctx.availableTasksFilter,
                      value: _ctx.selectedTask,
                      onValueChanged: _ctx.changeTaskList,
                      placeholder: "Type to Select Visit Type",
                      "show-all-by-default": true,
                      "open-on-focus": true,
                      "must-select-value": true,
                      onBlurredInput: _ctx.v$.selectedTask?.$touch,
                      class: _normalizeClass(`${!_ctx.v$.selectedTask?.$error ? '' : 'field-invalid'}`)
                    }, null, 8 /* PROPS */, ["getData", "value", "onValueChanged", "onBlurredInput", "class"]),
                    (_ctx.v$.selectedTask?.$error)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_17, "Visit Type is required."))
                      : _createCommentVNode("v-if", true)
                  ]))
                : _createCommentVNode("v-if", true),
              (!_ctx.isNva)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _hoisted_19,
                    _createVNode(_component_TypeaheadInput, {
                      placeholder: "Type to Select Patient",
                      getData: _ctx.getPatient,
                      value: _ctx.patientId,
                      onValueChanged: _ctx.patientIdChanged,
                      showAllByDefault: _ctx.showAllByDefault,
                      onBlurredInput: _ctx.v$.newVisitDetails.patientId.$touch,
                      class: _normalizeClass(`${!_ctx.v$.newVisitDetails.patientId.$error ? '' : 'field-invalid'}`)
                    }, null, 8 /* PROPS */, ["getData", "value", "onValueChanged", "showAllByDefault", "onBlurredInput", "class"]),
                    (_ctx.v$.newVisitDetails.patientId.$error)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_20, "Patient is required."))
                      : _createCommentVNode("v-if", true)
                  ]))
                : _createCommentVNode("v-if", true),
              (!_ctx.isNva)
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    _hoisted_22,
                    _hoisted_23,
                    (_ctx.visitOrders.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                          _createElementVNode("div", _hoisted_25, [
                            _createElementVNode("table", _hoisted_26, [
                              _createElementVNode("tbody", null, [
                                _hoisted_27,
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visitOrders, (order, index) => {
                                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                    _createElementVNode("td", null, _toDisplayString(order.discipline), 1 /* TEXT */),
                                    _createElementVNode("td", _hoisted_28, _toDisplayString(order.frequency), 1 /* TEXT */),
                                    _createElementVNode("td", _hoisted_29, _toDisplayString(order.effectiveDate), 1 /* TEXT */)
                                  ]))
                                }), 128 /* KEYED_FRAGMENT */))
                              ])
                            ])
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("p", _hoisted_30, "There are no current orders for visits."))
                  ]))
                : _createCommentVNode("v-if", true),
              (!_ctx.isNva)
                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                    _hoisted_32,
                    (!_ctx.currentEpisodeDetails)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_33, "Select patient to see the current episode"))
                      : (_openBlock(), _createElementBlock("div", _hoisted_34, [
                          _hoisted_35,
                          _createElementVNode("div", _hoisted_36, [
                            (_ctx.currentEpisodeDetails)
                              ? (_openBlock(), _createBlock(_component_MultiDatePickerHH, {
                                  key: 0,
                                  result: _ctx.visitDates,
                                  "current-episode-details": _ctx.currentEpisodeDetails,
                                  onUpdateResult: _ctx.updateResult,
                                  visitDates: _ctx.visitDatesList
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_37
                                  ]),
                                  _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["result", "current-episode-details", "onUpdateResult", "visitDates"]))
                              : _createCommentVNode("v-if", true),
                            (_ctx.v$.visitDates?.$error)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_38, " Visit Dates is Required. "))
                              : _createCommentVNode("v-if", true)
                          ]),
                          (_ctx.currentEpisodeDetails)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_39, _hoisted_41))
                            : _createCommentVNode("v-if", true)
                        ]))
                  ]))
                : _createCommentVNode("v-if", true),
              (_ctx.isNva)
                ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                    _hoisted_43,
                    _hoisted_44,
                    _createVNode(_component_DatePicker, { getDate: _ctx.onDateChange }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_45, [
                          _createElementVNode("input", {
                            type: "text",
                            name: "new-task-single-date",
                            class: _normalizeClass(["form-control", `${!_ctx.v$.newTaskSingleDate?.$error ? '' : 'field-invalid mt-0'}`]),
                            placeholder: "MM/DD/YYYY",
                            value: _ctx.formatDateInput(_ctx.newTaskSingleDate),
                            "on-change": (e) => _ctx.onDateChange(e.target.value, e.target.name),
                            autocomplete: "off",
                            onBlur: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.v$.newTaskSingleDate?.$touch && _ctx.v$.newTaskSingleDate?.$touch(...args)))
                          }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_46),
                          _hoisted_47
                        ]),
                        (_ctx.v$.newTaskSingleDate?.$error)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_48, "Date is required."))
                          : _createCommentVNode("v-if", true)
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["getDate"]),
                    (_ctx.v$.newTaskFlexDates?.$error)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_49, "Date is required."))
                      : _createCommentVNode("v-if", true)
                  ]))
                : _createCommentVNode("v-if", true),
              (_ctx.isNva)
                ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                    _hoisted_51,
                    _hoisted_52,
                    _createVNode(_component_TypeaheadInput, {
                      getData: _ctx.nvaAvailableTasksFilter,
                      value: _ctx.nvaActivity,
                      onValueChanged: _ctx.nvaActivityChanged,
                      "show-all-by-default": true,
                      "open-on-focus": true,
                      "must-select-value": true,
                      placeholder: "Type to Filter Task",
                      onBlurredInput: _ctx.v$.nvaActivity.$touch,
                      class: _normalizeClass(`${!_ctx.v$.nvaActivity?.$error ? '' : 'field-invalid'}`)
                    }, null, 8 /* PROPS */, ["getData", "value", "onValueChanged", "onBlurredInput", "class"]),
                    (_ctx.v$.nvaActivity?.$error)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_53, "Activity is required."))
                      : _createCommentVNode("v-if", true)
                  ]))
                : _createCommentVNode("v-if", true),
              (_ctx.isNva)
                ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                    _hoisted_55,
                    _withDirectives(_createElementVNode("select", {
                      class: "form-select",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedBranch) = $event)),
                      onBlur: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.v$.selectedBranch.id.$touch && _ctx.v$.selectedBranch.id.$touch(...args)))
                    }, [
                      _hoisted_56,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedBranches, (branch) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: branch,
                          key: branch.name
                        }, _toDisplayString(branch.name), 9 /* TEXT, PROPS */, _hoisted_57))
                      }), 128 /* KEYED_FRAGMENT */))
                    ], 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                      [_vModelSelect, _ctx.selectedBranch]
                    ]),
                    (_ctx.v$.selectedBranch?.id?.$error)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_58, "Branch is required."))
                      : _createCommentVNode("v-if", true)
                  ]))
                : _createCommentVNode("v-if", true),
              (_ctx.isNva)
                ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                    _hoisted_60,
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_61, [
                        _createVNode(_component_TimePicker, {
                          id: "travel-start-time",
                          onUpdateProps: _ctx.changeTravelStartTime
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("input", {
                              placeholder: "hh:mm AM",
                              class: _normalizeClass(`form-control`),
                              type: "text",
                              autocomplete: "off",
                              maxlength: "8",
                              value: _ctx.visitDetails.StartTime
                            }, null, 8 /* PROPS */, _hoisted_62)
                          ]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["onUpdateProps"])
                      ])
                    ])
                  ]))
                : _createCommentVNode("v-if", true),
              (_ctx.isNva)
                ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                    _hoisted_64,
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_65, [
                        _createVNode(_component_TimePicker, {
                          id: "travel-end-time",
                          onUpdateProps: _ctx.changeTravelEndTime
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("input", {
                              placeholder: "hh:mm AM",
                              class: _normalizeClass(`form-control`),
                              type: "text",
                              autocomplete: "off",
                              maxlength: "8",
                              value: _ctx.visitDetails.EndTime
                            }, null, 8 /* PROPS */, _hoisted_66)
                          ]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["onUpdateProps"])
                      ])
                    ])
                  ]))
                : _createCommentVNode("v-if", true),
              (_ctx.isNva)
                ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                    _hoisted_68,
                    _createVNode(_component_TimePicker, { onUpdateProps: _ctx.changeVisitTimeIn }, {
                      default: _withCtx(() => [
                        _createElementVNode("input", {
                          id: "nva-start-time",
                          type: "text",
                          class: "form-control",
                          autocomplete: "off",
                          value: _ctx.visitDetails.TimeIn,
                          placeholder: "hh:mm AM"
                        }, null, 8 /* PROPS */, _hoisted_69)
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onUpdateProps"])
                  ]))
                : _createCommentVNode("v-if", true),
              (_ctx.isNva)
                ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                    _hoisted_71,
                    _createVNode(_component_TimePicker, { onUpdateProps: _ctx.changeVisitTimeOut }, {
                      default: _withCtx(() => [
                        _createElementVNode("input", {
                          placeholder: "hh:mm AM",
                          id: "nva-end-time",
                          type: "text",
                          class: "form-control",
                          autocomplete: "off",
                          value: _ctx.visitDetails.TimeOut
                        }, null, 8 /* PROPS */, _hoisted_72)
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onUpdateProps"])
                  ]))
                : _createCommentVNode("v-if", true),
              (_ctx.isNva)
                ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                    _hoisted_74,
                    _withDirectives(_createElementVNode("select", {
                      id: "destination",
                      class: "form-select",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.Destination) = $event))
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.DestinationList, (Destination, index) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: index,
                          key: Destination
                        }, _toDisplayString(Destination), 9 /* TEXT, PROPS */, _hoisted_75))
                      }), 128 /* KEYED_FRAGMENT */))
                    ], 512 /* NEED_PATCH */), [
                      [_vModelSelect, _ctx.Destination]
                    ])
                  ]))
                : _createCommentVNode("v-if", true),
              (_ctx.isNva)
                ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                    _hoisted_77,
                    _withDirectives(_createElementVNode("input", {
                      id: "associated-mileage",
                      type: "text",
                      class: "form-control",
                      placeholder: "Enter Amount",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.associatedMileage) = $event)),
                      "number-only": "",
                      maxlength: "7"
                    }, null, 512 /* NEED_PATCH */), [
                      [_vModelText, _ctx.associatedMileage]
                    ])
                  ]))
                : _createCommentVNode("v-if", true),
              (_ctx.isNva)
                ? (_openBlock(), _createElementBlock("section", _hoisted_78, [
                    _createElementVNode("div", _hoisted_79, [
                      _hoisted_80,
                      _withDirectives(_createElementVNode("textarea", {
                        class: _normalizeClass(`form-control commentInputClass`),
                        rows: "4",
                        name: "referral-comments",
                        placeholder: "Enter Comments",
                        maxlength: "200",
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.comments) = $event))
                      }, null, 512 /* NEED_PATCH */), [
                        [_vModelText, _ctx.comments]
                      ])
                    ])
                  ]))
                : _createCommentVNode("v-if", true)
            ])
          ])),
      (!_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
            (_ctx.isSaving)
              ? (_openBlock(), _createElementBlock("span", _hoisted_82, _hoisted_84))
              : (_openBlock(), _createElementBlock("span", _hoisted_85, [
                  _createElementVNode("button", {
                    class: "btn btn-primary",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.scheduleVisit(_ctx.SaveEnum.SaveAndExit)))
                  }, "Save and Exit"),
                  _createVNode(_component_SaveNotifyUser, {
                    "agency-id": _ctx.visitDetails.AgencyId,
                    "button-name": "Save and Notify Employee",
                    onHandleSaveVisit: _cache[9] || (_cache[9] = ($event: any) => (_ctx.scheduleVisit(_ctx.SaveEnum.SaveAndNotifyEmployee)))
                  }, null, 8 /* PROPS */, ["agency-id"]),
                  _createElementVNode("button", {
                    class: "ms-2 btn btn-primary",
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.scheduleVisit(_ctx.SaveEnum.SaveAndAddAnother)))
                  }, " Save and Add Another "),
                  _createElementVNode("button", {
                    type: "button",
                    class: "ms-2 btn btn-md btn-outline-secondary",
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.cancel()))
                  }, " Cancel ")
                ]))
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["application-id"]))
}